import Long from 'long';

export default function formatIdTitle(id?: Long | null): string {
  return id ? `ID:${id?.toString()}` : '';
}
